<template>
  <div class="tip-match-props-check-list">
    <div
      v-for="(item,index) in propsCheckList"
      :key="index"
      class="tip-match-props-check-item"
      @click.stop="onItemClick(item)"
    >
      <div class="tip-match-props-check-img">
        <img
          v-if="item.goodscfg && item.goodscfg.goodsicon"
          :src="getCompressImgUrl(item.goodscfg.goodsicon, 98, 98)"
        >
      </div>
      <div class="tip-match-props-check-info">
        <div class="tip-match-props-detail">
          <p class="tip-match-props-name">
            {{ item.displayName }}
          </p>
          <p
            v-if="propType"
            class="tip-match-props-check-label"
          >
            {{ propType }}
          </p>
          <p
            v-else
            class="tip-match-props-check-label"
          >
            兑换有效期至{{ item.displayOverduetime }}
          </p>
        </div>
        <p
          v-if="item.isShowCheck"
          class="tip-match-props-check-price"
        >
          &yen;{{ item.propsPrice }}
        </p>
        <p
          v-else
          class="tip-match-props-check-num"
        >
          数量：{{ item.propsNum || 1 }}
        </p>
      </div>
      <!-- 选中添加类名：tip-match-props-checked -->
      <div
        v-if="item.isShowCheck"
        :class="['tip-match-props-check',
                 item.isChecked ? 'tip-match-props-checked':'']"
        @click.stop="onCheckClick(item)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PropsCheck',
  props: {
    propsCheckList: {
      type: Array,
      default: () => [
        {
          goodscfg: {
            goodsicon: 'https://dummyimage.com/200x200',
          },
          displayName: '道具名称',
          displayOverduetime: '2/2',
          propsPrice: '18.88',
          propsNum: '1',
          isShowCheck: false,
          isChecked: false,
        }, {
          goodscfg: {
            goodsicon: 'https://dummyimage.com/200x200',
          },
          displayName: '道具名称',
          displayOverduetime: '2/2',
          propsPrice: '18.88',
          propsNum: '1',
          isShowCheck: false,
          isChecked: false,
        },
      ],
      required: true,
    },
    propType: {
      type: String,
      default: '',
    },
  },
  options: {
    virtualHost: true,
  },
  data() {
    return {
    };
  },
  computed: {

  },
  methods: {
    onCheckClick(...args) {
      this.$emit('onCheckClick', ...args);
    },
    onItemClick(...args) {
      this.$emit('onItemClick', ...args);
    },
  },
};

</script>
<style lang="scss" scoped src="./css/index.scss"></style>
